import React from 'react';
import { Link } from 'react-router-dom';
import './Model.css';

const Headers = ({ to, active, point }) => {
  let newPoint = point;
  if (!to.includes('artist') && to.includes('biography')) {
    newPoint = 'about';
  }
  return (
    <Link className="model_header_point" to={to}>
      <div className={`model_header_point_dot_${active ? '' : 'in'}active`} />
      {newPoint}
    </Link>
  );
};

const CategoryHeaders = (type, category, ...args) => args.map(([point, to]) => (
  <Headers to={`/${type}/${point}`} point={point} active={category === to || (category === 'hair & makeup' && to.includes('hair-makeup'))} key={point} />
));

function RepresentativeHeaders(match, galleries) {
  const {
    type,
    category,
    gallery,
    name,
  } = match.params;
  return galleries.map((point) => (
    <Headers to={`/${type}/${category}/${point}/${name}`} point={point} active={gallery === point} key={point} />
  ));
}

const SheHeHeader = [['mainboard', 'mainboard'], ['image', 'image'], ['direct', 'direct'], ['development', 'development'], ['classic', 'classic']];
const ArtistHeader = [['hair & makeup', 'hair-makeup'], ['stylist', 'stylist']];

export default ({ match, galleries }) => {
  const { type, category, name } = match.params;
  const isPersonPage = name !== undefined;
  const RepHeaders = type === 'he' || type === 'she' ? SheHeHeader : ArtistHeader;
  const headers = (
    isPersonPage
      ? RepresentativeHeaders(match, galleries)
      : CategoryHeaders(type, category, ...RepHeaders)
  );
  return (
    <div className="model_links">
      {headers}
    </div>
  );
};
